const paths = {
  share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 10.5 6.8-4m-6.8 7 6.8 4"/>',
  swap: '<path d="M4 8h16m-4-4 4 4-4 4M20 16H4m4-4-4 4 4 4"/>',
  shuffle: '<path d="M3 6h3l12 12h3M3 18h3l4-4m4-4 4-4h3m-3-3 3 3-3 3m0 6 3 3-3 3"/>',
  expand: '<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/>',
  collapse: '<path d="M3 8h5V3m8 0v5h5M8 21v-5H3m18 0h-5v5"/>',
  menu: '<path d="M4 6h16M4 12h16M4 18h16"/>',
  settings: '<path d="m10 3-1 3-3 1-3-1-1 3 2 2v3l-2 2 1 3 3-1 3 1 1 3h4l1-3 3-1 3 1 1-3-2-2v-3l2-2-1-3-3 1-3-1-1-3Z"/><circle cx="12" cy="12" r="3"/>',
  back: '<path d="m10 5-7 7 7 7M3 12h18"/>',
  arrow: '<path d="m9 5 7 7-7 7"/>',
  backspace: '<path d="m8 5-6 7 6 7h13V5Z M11 9l6 6m0-6-6 6"/>',
  clear: '<path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7m4-7v7"/>',
  stats: '<path d="M5 21V12h3v9m3 0V3h3v18m3 0V8h3v13"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  crown: '<path d="m3 7 4 5 5-8 5 8 4-5-2 12H5Z"/>',
  player: '<circle cx="12" cy="7" r="4"/><path d="M5 21v-3a7 7 0 0 1 14 0v3Z"/>',
  warning: '<circle cx="12" cy="12" r="9"/><path d="M12 7v6m0 4h.01"/>',
  close: '<path d="m6 6 12 12M18 6 6 18"/>',
  book: '<path d="M12 5v16M3 4c4-1 6 0 9 2 3-2 5-3 9-2v15c-4-1-6 0-9 2-3-2-5-3-9-2Z"/>',
  keyboard: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M6 9h.01M10 9h.01M14 9h.01M18 9h.01M6 12h.01M10 12h.01M14 12h.01M18 12h.01M7 16h10"/>',
  globe: '<circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  clipboard: '<rect x="5" y="5" width="14" height="16" rx="2"/><rect x="8" y="2" width="8" height="5" rx="2"/><path d="m8 13 3 3 5-5"/>',
  play: '<path d="m8 4 12 8-12 8Z"/>',
  music: '<path d="M9 18V5l12-2v13M9 8l12-2"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
};

export function createIcon(name) {
  const wrapper = document.createElement('span');
  wrapper.className = 'icon';
  wrapper.setAttribute('aria-hidden', 'true');
  // Only the local, fixed icon paths above are inserted as markup.
  wrapper.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths[name] ?? paths.arrow}</svg>`;
  return wrapper;
}

export function applyIcons(root = document) {
  for (const placeholder of root.querySelectorAll('[data-icon]')) placeholder.replaceChildren(createIcon(placeholder.dataset.icon));
}
